export default "__VITE_ASSET__DdtgbbG9__"